module.exports = __webpack_public_path__ + "static/media/banner.41bad686.png";